import React from "react";
import {Route,Routes,Router} from "react-router-dom";
import Home from "../Home";
import Usage from "../Usage";
import Contents from "../Contents";
import FAQ from "../FAQ";
import Cart from "../Cart";
import Header from "./Header";
import Footer from "./Footer";
import Location from "../Location";
import ManagerPage from "../ManagerPage";
import ReservationPopup from "../ReservationPopup";
import Privacy from "../Privacy";

const RouterWhitHeader=()=>{
    return(
        <>
            <Header/>
            <Routes>
                <Route path={'/'} element ={<Home/>}/>
                <Route path={'/usage'} element ={<Usage/>}/>
                <Route path={'/contents'} element ={<Contents/>}/>
                <Route path={'/faq'} element ={<FAQ/>}/>
                <Route path={'/cart'} element ={<Cart/>}/>
                <Route path={'/location'} element ={<Location/>}/>
                <Route path={'/manager-page'} element ={<ManagerPage/>}/>
                <Route path={'/reservation-popup'} element ={<ReservationPopup/>}/>
                <Route path={'/privacy'} element ={<Privacy/>}/>
                <Route path={"*"} element={<div>없는 페이지 입니다.</div>}/>
            </Routes>
            <Footer/>
        </>
    )
}

export default RouterWhitHeader
